__webpack_require__.p = "https://static.foqal.io/knowledge/";